/**
=========================================================
* Material Dashboard 2 PRO React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 PRO React helper functions
import pxToRem from "assets/theme-dark/functions/pxToRem";
import { ESCURO, TEXTO_COLORIDO_ESCURO } from "assets/coresTema";

const icon = {
  defaultProps: {
    baseClassName: "material-icons-round",
    fontSize: "inherit",
  },

  styleOverrides: {
    // ícone com cor do tema que some no cinza dos blocos: tons claros legíveis
    root: {
      "&.MuiIcon-colorInfo": { color: TEXTO_COLORIDO_ESCURO.info },
      "&.MuiIcon-colorPrimary": { color: TEXTO_COLORIDO_ESCURO.primary },
      "&.MuiIcon-colorSecondary": { color: ESCURO.textoSecundario },
    },

    fontSizeInherit: {
      fontSize: "inherit !important",
    },

    fontSizeSmall: {
      fontSize: `${pxToRem(20)} !important`,
    },

    fontSizeLarge: {
      fontSize: `${pxToRem(36)} !important`,
    },
  },
};

export default icon;
